import { render, staticRenderFns } from "./Orderform.vue?vue&type=template&id=34c6aa19&scoped=true"
import script from "./Orderform.vue?vue&type=script&lang=js"
export * from "./Orderform.vue?vue&type=script&lang=js"
import style0 from "./Orderform.vue?vue&type=style&index=0&id=34c6aa19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6aa19",
  null
  
)

export default component.exports